import { reducer as toastrReducer } from 'react-redux-toastr';
import auth from './auth';

const coreReducers = {
    auth,
    toastr: toastrReducer,
};

export default coreReducers;
